import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { PeopleSearchInputModule } from '@app/src/app/components/people-search-input';
import { MgIconModule } from '@app/src/app/icon';
import { PermissionsModule } from '@app/src/app/permissions';
import { MembershipListTableModule } from '@app/src/app/shared/components/membership-list-table';
import { MobileCardModule } from '@app/src/app/shared/components/tables/mobile-card/mobile-card.module';
import { SortHeaderModule } from '@app/src/app/shared/directives/sort-header/sort-header.module';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { GenericButtonModule } from '@shared/components/button';
import { CollapsibleModule } from '@shared/components/collapsible';
import { FormModule } from '@shared/components/form';
import { FormRestrictionModule } from '@shared/components/form-restriction-input/form-restriction-input.module';
import { FormImageSelectModule } from '@shared/components/form/components/form-image-select/form-image-select.module';
import { GenericModule } from '@shared/components/generic';
import { ManagerOverlayModule } from '@shared/components/manager-overlay';
import { OverlayModule } from '@shared/components/modal-overlay';
import { PaginatorModule } from '@shared/components/paginator';
import { SystemAlertModule } from '@shared/components/system-alert';
import { TextModule } from '@shared/components/text/text.module';
import { TooltipModule } from '@shared/components/tooltip';

import { FtmSharedModule } from '../ftm-shared/ftm-shared.module';
import { FtmAtEditComponent } from './components/ftm-at-edit/ftm-at-edit.component';
import { FtmActivityTemplatesComponent } from './ftm-activity-templates.component';

@NgModule({
  declarations: [FtmActivityTemplatesComponent, FtmAtEditComponent],
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MgSpinnerModule,
    MgEmptyStateModule,
    FlexModule,
    OverlayModule,
    FormModule,
    ReactiveFormsModule,
    ManagerOverlayModule,
    FormImageSelectModule,
    MgIconModule,
    MatSlideToggleModule,
    TextModule,
    PeopleSearchInputModule,
    FormRestrictionModule,
    FtmSharedModule,
    PermissionsModule,
    CollapsibleModule,
    GenericModule,
    GenericButtonModule,
    TooltipModule,
    MatTooltipModule,
    SystemAlertModule,
    SortHeaderModule,
    MobileCardModule,
    PaginatorModule,
    FlexLayoutModule,
    MembershipListTableModule,
  ],
})
export class FtmActivityTemplatesModule {}
